import { Model } from 'miragejs';

export const models = {
  //API Search
  datafilter: Model,
  //API Billing
  contract: Model,
  billingcustomer: Model,
  installment: Model,
  payment: Model,
  //API Insurance
  policy: Model,
  insurancecustomer: Model,
  contact: Model,
  address: Model,
  //API Customer
  interaction: Model,
  ticket: Model,
};
